import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '6.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2.5rem'
    }
  },
  textBox: {
    width: '65%',
    padding: '2.75rem 5.125rem ',
    borderTop: '1px black solid',
    borderBottom: '1px black solid',
    [theme.breakpoints.down('sm')]: {
      width: '86%',
      padding: '2rem 0'
    }
  },
  pg1: {
    marginTop: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem'
    }
  },
  bolded: {
    ...theme.typography.body2,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '28px'
    }
  },
  mobileH3: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      lineHeight: '18px'
    }
  },
  mobileBody1: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '28px',
      letterSpacing: '.5px'
    }
  }
}));

const FindingSupport = () => {
  const classes = useStyles();
  return (
    <Grid container direction="column" alignItems="center" className={classes.wrapper}>
      <Grid container direction="column" className={classes.textBox}>
        <Grid item>
          <Typography variant="h3" className={classes.mobileH3}>
            FINDING SUPPORT THROUGH CONNECTION
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            As a navigator, Nikki is empowered to reach out and proactively assist members with the
            many things that can impact their overall health – from helping to coordinate care,
            address claims issues, provide social support and assist with other needs. And the
            support Pat received was made possible through her personal, authentic and trusted
            connection with Nikki.
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            <span className={classes.bolded}>NIKKI:</span> I think during the first few calls, we
            definitely were, more, figuring each other out. By about the third call, Pat opened up.
            That's when I got her list of the different things that she wanted to accomplish. And
            then we just slowly tackled each of those things.
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            <span className={classes.bolded}>PAT:</span> Having a personal navigator allowed me to
            have this huge sigh of relief. If you are the person who is accountable, the buck stops
            here. Because of my anxiety, and depression, sometimes I’d call on the phone and freeze
            up, but with Nikki – her competence led me to feel reassured and confident in myself.
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            <span className={classes.bolded}>NIKKI:</span> Over the first month of our calls last
            year, I think I gained Pat’s trust, which then turned into more of a friendship.
            Because, even if we didn't take something off our checklist each time, we still got to,
            you know, shoot the crap.
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            <span className={classes.bolded}>PAT:</span> That day Nikki said to me "Is this a good
            time for you?" That was remarkable, because nobody had ever asked me that before. I just
            don’t think you can train empathy. I think Nikki has a gift.
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            <span className={classes.bolded}>NIKKI:</span> We built such a tight relationship over
            the phone. We would take time, like even if maybe it wasn't a good day to tackle a
            situation, we would talk about the yard, and Pat’s ‘little house in the big yard.’ And
            that was something that I always knew I could talk about.
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FindingSupport;
